
export default class CustomerStats {
    bidPeriodId: number = 0;
    customerId: number = 0;
    base: string | null = null;
    aircraftGroup: string | null = null;
    position: string | null = null;
    extendedData: string | null = null;
    created: string | null = null;
    lastModified: string | null = null;
}
